module.exports = __webpack_public_path__ + "img/uga.be11ef39.svg";